module.exports = __webpack_public_path__ + "assets/img/modal-avatar-0f9e189a.png";